<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from "../themeConfig";
import { provideToast } from "vue-toastification/composition";
import { watch } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";

import { useWindowSize, useCssVar } from "@vueuse/core";

import store from "@/store";
import Cookies from 'js-cookie'

const LayoutVertical = () => import("@/layouts/vertical/LayoutVertical.vue");
const LayoutFull = () => import("@/layouts/full/LayoutFull.vue");
const LayoutMobile = () => import("@/layouts/mobile/LayoutMobile.vue");
const LayoutHorizontal = () => import("@/layouts/horizontal/LayoutHorizontal.vue");

export default {
  metaInfo: {
    title: Title,
    titleTemplate: titleTemplate,
    htmlAttrs: htmlAttrs,
    meta: meta,
  },
  components: {
    // Layouts
    LayoutVertical,
    LayoutFull,
    LayoutMobile,
    LayoutHorizontal

  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      
      if(this.$mobile==1)return "layout-mobile";
      return `layout-vertical`;
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
  },

  beforeCreate() {
    // Set colors in theme
    // const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // // eslint-disable-next-line no-plusplus
    // for (let i = 0, len = colors.length; i < len; i++) {
    //   $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    // }
    // // Set Theme Breakpoints
    const breakpoints = ["xs", "sm", "md", "lg", "xl"];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement
        ).value.slice(0, -2)
      );
    }

    // Set RTL
    // const { isRTL } = $themeConfig.layout;
    const locale = localStorage.getItem("locale");

    let isRTL = true;
    if (locale == "en") {
      isRTL = false;
    }

    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
  },
  setup() {
    const { skin, skinClasses } = useAppConfig();

    // If skin is dark when initialized => Add class to body
    if (skin.value === "dark") document.body.classList.add("dark-layout");

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: "Vue-Toastification__fade",
    });

    // Set Window Width in store
    store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);
    const { width: windowWidth } = useWindowSize();
    watch(windowWidth, (val) => {
      store.commit("app/UPDATE_WINDOW_WIDTH", val);
    });

    return {
      skinClasses,
    };
  },
  
};
</script>
<style >
/* Regular weight */
@font-face {
  font-family: "NeoSans";
  src: url("./assets/fonts/NeoSansArabicRegular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* Light weight */
@font-face {
  font-family: "NeoSans";
  src: url("./assets/fonts/NeoSansArabicLight.ttf") format("truetype");
  font-weight: 300; /* Light weight */
  font-style: normal;
}

/* Medium weight */
@font-face {
  font-family: "NeoSans";
  src: url("./assets/fonts/NeoSansArabicMedium.ttf") format("truetype");
  font-weight: 500; /* Medium weight */
  font-style: normal;
}

/* Bold weight */
@font-face {
  font-family: "NeoSans";
  src: url("./assets/fonts/NeoSansArabicBold.ttf") format("truetype");
  font-weight: bold; /* Bold weight */
  font-style: normal;
}
@font-face {
  font-family: "droid";
  src: url("./assets/fonts/ArbFONTS-Droid Arabic Kufi.ttf");
}
body {
  font-family: "droid" !important;
}
.navigation {
  font-size: 1rem;
  font-family: inherit !important;
}
.card .card-title {
  font-weight: bold !important;
}

.notifi-card {
  width: 100%;
  height: 8.6111111111rem;
  border-width: 3px !important;
  border-style: solid !important;
  border-radius: 15px;
  margin: 0 auto;
  overflow: hidden;
  padding: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.notifi-card .title p {
  font-weight: bold;
}
.notifi-card .title h2 {
  font-weight: bold;
  font-family: "Montserrat";
}
.notifi-card i {
  align-self: flex-start;
  font-size: 1.3rem;
}

.dark-layout .notifi-card {
  background-color: #283046 !important;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 24%) !important;
}

.draggable-zone-1 .announcement-item {
  min-width: 33.33%;
}
.draggable-zone-1 .statistics-item,
.draggable-zone-1 .statistics-ver {
  min-width: 50%;
}
.draggable-zone-1 .calendar-area,
.draggable-zone-1 .tabs-area {
  min-width: 100%;
}
.draggable-zone-1 .calendar-area .b-calendar,
.draggable-zone-1 .calendar-area .b-calendar .b-calendar-inner {
  width: 100% !important;
}
/* .loading {
  width: 7rem;
  height: 7rem;
  position: fixed;
  right: 50vw;
  top: 40vh;
} */
</style>
